import React, {useEffect} from 'react';
import {Route, Switch, useHistory} from 'react-router-dom';
import asyncComponent from '../../../util/asyncComponent';
import Dashboard from "./routes/Dashboard";
import {
    bbFindEntityWithinPortfolioOrSelf,
    bbIsBetasOk,
    getFirstCustomerId,
    isCurrentUserMemberOf
} from "../../../util/bbHelpers";
import {useDispatch, useSelector} from "react-redux";
import URLSearchParams from "url-search-params";
import SettingsPage from "./routes/settingsSubscription"
import MultiBoardWrapper from "../cirt/routes/MultiBoardWrapper";
import {fetchCustomers, fetchRiskPortfolio, setCustomerInView, setEntityInView} from "../../../actions";
import ManageSubscriptionPage from "./routes/ManageSubscription/ManageSubscriptionPage";
import RegistrationIncompleteDialog from "../../../components/customBreachBits/modals/RegistrationIncompleteDialog";
import MultiCustomerBRWrapper from "../brbusiness/routes/MultiCustomerBRWrapper";

function PageRoutes({match, betasOk, authUser}) {


    return(
        <div className="px-3 py-4">
            <RegistrationIncompleteDialog/>
        <Switch>
            {/*<Redirect exact from={`${match.url}`} to={`${match.url} `}/>*/}
            <Route path={`${match.url}/account`} component={SettingsPage}/>
            <Route path={`${match.url}/subscription`} component={ManageSubscriptionPage}/>
            {/*<Route path={`${match.url}/`} component={Dashboard}/>*/}
            <Route component={asyncComponent(() => import('app/routes/extraPages/routes/404'))}/>
        </Switch>
        </div>
    );
}

const DashboardPages = ({match}) => {

    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {authUser} = useSelector(({auth}) => auth);
    const history = useHistory();
    const dispatch = useDispatch();
    const numCustomers = customers ? Object.keys(customers).length : 0;
    const {entityInView, portfolios, loadingPortfolios, selfEntityId, loadingCycles, loadingCycleDetails, loadingCycleSocial} = useSelector(({breachrisk}) => breachrisk);
    const customerIdToUse = customers ? customerInView ? customerInView : null : null;

    const customer = customers ? customers[customerInView] : null;

    const isPartner = isCurrentUserMemberOf(authUser, "partner");
    const isAdmin =  isCurrentUserMemberOf(authUser, "admin");
    const isStaff = isCurrentUserMemberOf(authUser, "staff");

    // const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);


    useEffect(() => {

        if (customers == null && authUser) {
            console.log("Customers is empty, fetching from CIRTPages. numCustomers is ", numCustomers);
            dispatch(fetchCustomers());
        }
        if (numCustomers && customerInView === null) {
            const defaultId = getFirstCustomerId(customers);
            // console.log("setting view to default customer, first in list: ", defaultId);
            dispatch(setCustomerInView(defaultId));
        }

    /*  jfd*******************************
     *   Appending clientID to URL
         ********************************** */
    const params = new URLSearchParams(window.location.search);


    if ((isPartner
        || isAdmin
        || isStaff
    )) {
        //if they are a partner, staff, or admin, append the clientID routes param

        if(customers
            && !params.has("clientID")
            && customerInView
        ) {
            //set the urlParameters
            params.set("clientID", customerInView)
            // console.log("getting params", params.get("clientID"));
            history.replace({
                search: params.toString(),
            })
        }
    }

        /*  jfd*******************************
                     *   Fetch Portfolios
                         ********************************** */

        // console.log("About to fetch BreachRisk stuff. Here is customers", customers, "And here is in view", customer)

        if (customers && customer && authUser && !portfolios && !loadingPortfolios[customerInView]) {
            // console.log("Portfolios is empty, fetching for customerId", customer.CustomerId);
            dispatch(fetchRiskPortfolio({
                customerId: customer.CustomerId
            }));
        }

        /*  jfd*******************************
                 *   Set entityInView
                     ********************************** */
        if (portfolios
            && portfolios[customerIdToUse]
            && portfolios[customerIdToUse].self
        ) {
            const defaultId = portfolios[customerIdToUse].self.id;
            // console.log("setting view to default customer, first in list: ", defaultId);
            dispatch(setEntityInView(defaultId));
            // console.log("set the entity in view to Self", defaultId);
        }

    }, [dispatch, customers, customerInView, window.location.search, portfolios, loadingPortfolios, authUser, customer, customerIdToUse, entityInView]);


    // return <div className="px-3 py-4">
    //     <Switch>
    //         {/*<Redirect exact from={`${match.url}`} to={`${match.url} `}/>*/}
    //         <Route path={`${match.url}/subscription`} component={settingsSubscriptionPage}/>
    //         <Route path={`${match.url}/`} component={Insights}/>
    //
    //
    //         <Route component={asyncComponent(() => import('app/routes/extraPages/routes/404'))}/>
    //     </Switch>
    // </div>

    //}
    if ((isAdmin || isStaff || isPartner) ) {
        return (
            <MultiCustomerBRWrapper customer={customers ? customers[customerIdToUse] : null}>
                <PageRoutes match={match} betasOk={bbIsBetasOk(authUser)} isAdmin={isAdmin}/>
            </MultiCustomerBRWrapper>
        )
    }else if (isCurrentUserMemberOf(authUser, "customer") && !isCurrentUserMemberOf(authUser, "admin")){
        return (
            <>
                <PageRoutes match={match} betasOk={bbIsBetasOk(authUser)} authUser={authUser}/>
            </>
        )
    } else {
        return (
            <PageRoutes match={match} betasOk={bbIsBetasOk(authUser)}/>
        )
    }
};

export default DashboardPages;
